import loadable from '@loadable/component';
import { RouteConfig } from 'react-router-config';
import { Layout } from 'src/app/shared/components/layout';
import { AdminRoutePath } from 'src/entities/adminRoute';

export const routesConfig: RouteConfig[] = [
  {
    exact: true,
    component: Layout,
    routes: [
      {
        path: AdminRoutePath.Home,
        exact: true,
        component: loadable(() => import('../../pages/home')),
      },
      {
        path: AdminRoutePath.ModerationVacancies,
        exact: true,
        component: loadable(() => import('../../pages/moderationVacancies')),
      },
      {
        path: AdminRoutePath.ModerationClientPatronage,
        exact: true,
        component: loadable(() => import('../../pages/moderationClientPatronage')),
      },
      {
        path: AdminRoutePath.ServiceCaching,
        exact: true,
        component: loadable(() => import('../../pages/service')),
      },
      {
        path: AdminRoutePath.Messages,
        component: loadable(() => import('../../pages/messages')),
      },
      {
        path: AdminRoutePath.ResponseDelay,
        component: loadable(() => import('../../pages/responseDelay')),
      },
      {
        path: AdminRoutePath.Specialists,
        component: loadable(() => import('../../pages/specialists')),
      },
      {
        path: AdminRoutePath.Employers,
        component: loadable(() => import('../../pages/employers')),
      },
      {
        path: AdminRoutePath.Vacancies,
        component: loadable(() => import('../../pages/vacancies')),
      },
      {
        path: AdminRoutePath.Promocodes,
        component: loadable(() => import('../../pages/promocode')),
      },
      {
        path: AdminRoutePath.RouteBlocks,
        component: loadable(() => import('../../pages/routeBlocks').then((module) => module.RouteBlocks)),
      },
      {
        path: AdminRoutePath.RoutesMeta,
        component: loadable(() => import('../../pages/routesMeta').then((module) => module.RoutesMetaPage)),
      },
      {
        path: AdminRoutePath.Blocks,
        component: loadable(() => import('../../pages/blocks').then((module) => module.Blocks)),
      },
      {
        path: AdminRoutePath.Subscriptions,
        component: loadable(() => import('../../pages/subscriptions').then((module) => module.SubscritptionsPage)),
      },
      {
        path: AdminRoutePath.Invoices,
        component: loadable(() => import('../../pages/invoices').then((module) => module.InvoicesPage)),
      },
      {
        path: AdminRoutePath.ThirdPartyApi,
        exact: true,
        component: loadable(() => import('../../pages/thirdPartyApi')),
      },
      {
        path: AdminRoutePath.ProcessingAndReviews,
        exact: true,
        component: loadable(() => import('../../pages/processingAndReviews')),
      },
      {
        path: '*',
        exact: true,
        component: loadable(() => import('../../pages/notFound')),
      },
    ],
  },
];
